import { Component, OnInit, ViewChild } from '@angular/core';
import { ClinicProductService } from 'src/app/_services/clinic-product.service';
import { MenuItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { CreateClinicProductComponent } from '../create-clinic-product/create-clinic-product.component';
import { DialogService } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/_services/user.service';
@Component({
  selector: 'app-clinic-products',
  templateUrl: './clinic-products.component.html',
  styleUrls: ['./clinic-products.component.scss'],
})
export class ClinicProductsComponent implements OnInit {
  @ViewChild('cm') cm: any;

  clinicProducts: any[] = [];
  filteringFor: string = '';
  selectedRow: any;
  userRole: string | undefined;

  metaData = {
    totalRecords: 0,
    limit: 100,
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  menuItems: MenuItem[] = [];

  productColumns: any[] = [
    {
      field: 'stock_item_code',
      header: 'Stock Item Code',
    },
    {
      field: 'size',
      header: 'Size',
    },
    {
      field: 'description',
      header: 'Description',
    },
    {
      field: 'quantity',
      header: 'Quantity',
    },
    {
      field: 'cost_excl_vat',
      header: 'Cost Excl. VAT',
    },
    {
      field: 'cost_incl_vat',
      header: 'Cost Incl. VAT',
    },
    {
      field: 'is_active',
      header: 'Status',
    },
  ];

  constructor(
    private clinicProductService: ClinicProductService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialogService: DialogService,
    public userService: UserService

  ) {}

  ngOnInit(): void {
    this.userService.loadTheCurrentUser().subscribe((user) => {
      this.userRole = user?.role?.name;
      console.log('User Role:', this.userRole);
    });
    

    this.menuItems = [
      {
        label: 'Enable/Disable Product',
        icon: 'pi pi-power-off',
        command: () => {
          this.confirmToggleProduct(this.selectedRow);
        }
      },
    ];
  }

  getFilterInputValue(e: Event): any {
    const inputelement = e.target as HTMLInputElement;
    this.filteringFor = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringFor = '';
    }
    return inputelement.value;
  }

  confirmToggleProduct(product: any) {
    this.confirmationService.confirm({
      message: product.is_active
        ? 'Are you sure you want to disable this product?'
        : 'Are you sure you want to enable this product?',
        key: 'productToggle',
      accept: () => {
        this.clinicProductService
          .toggleClinicProduct(product.id)
          .subscribe(() => {
            this.loadProductsLazy({
              first: this.metaData.offset,
              rows: this.metaData.limit,
              globalFilter: this.metaData.globalFilter,
              sortField: this.metaData.sort,
            });
            this.confirmationService.close();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: product.is_active
                ? 'Product disabled successfully'
                : 'Product enabled successfully',
              key: 'main',
            });
          });
      },
    });
  }

  loadProductsLazy(event: any) {
    this.metaData = {
      ...this.metaData,
      limit: event?.rows || 100,
      offset: event?.first || 0,
      loading: true,
      globalFilter: event?.globalFilter || '',
      sort: event?.sortField || '',
    };

    console.log('Loading products with event:', this.metaData);

    this.clinicProductService.getAllClinicProducts(this.metaData).subscribe(
      (response: any) => {
        this.clinicProducts = response.body.data;
        this.metaData.totalRecords = response.body.count;
        this.metaData.loading = false;
      },
      (error: any) => {
        console.error('Error loading clinic products:', error);
        this.metaData.loading = false;
      }
    );
  }

  showContextMenu(event: any, product: any) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedRow = product;
    this.cm.show(event);
  }

  openCreateProductDialog() {
    const ref = this.dialogService.open(CreateClinicProductComponent, {
      header: 'Create New Clinic Product',
      width: '70%',
      height: '70%',
      closeOnEscape: true,
    });

    ref.onClose.subscribe((created: boolean) => {
      if (created) {
        this.loadProductsLazy({
          first: this.metaData.offset,
          rows: this.metaData.limit,
          globalFilter: this.metaData.globalFilter,
          sortField: this.metaData.sort,
        });
      }
    });
  }
}
